<template>
  <validation-provider
    :disabled="!validatable"
    v-slot="validationContext"
    :name="fieldName || label"
    :rules="validatable ? rules : ''"
    :vid="vid"
    slim
  >
    <BaseAutocompleteInner
      :disabled="isDisabled"
      v-bind="$attrs"
      :value="value"
      :validationContext="validationContext"
      @input="emitValue"
      :validatable="validatable"
      :label="label"
      :fieldName="fieldName"
      :initialQuery="initialQuery"
      :textFn="textFn"
      @options="$emit('options', $event)"
    />
  </validation-provider>
</template>

<script>
import BaseAutocompleteInner from "./BaseAutocompleteInner";
export default {
  components: {
    BaseAutocompleteInner,
  },
  props: {
    textFn: {
      type: Function,
      default: (d) => d,
    },
    validatable: {
      type: Boolean,
      default: false,
    },
    vid: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    fieldName: {
      type: String,
      default: null,
    },
    rules: {
      type: String,
      default: "required",
    },
    value: null,
    initialQuery: null,
    disabled: {
      type: Boolean | undefined,
      default: () => undefined,
    },
    nextTick: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDisabled() {
      // need this wrapper for disabled prop (false value does not work)
      if (this.$props.disabled == null) return undefined;
      return true;
    },
  },
  methods: {
    emitValue($event) {
      if (this.nextTick) {
        this.$nextTick(() => {
          this.$emit("input", $event);
        });
      } else {
        this.$emit("input", $event);
      }
    },
  },
};
</script>
